import { ShieldCheck } from "lucide-react";

export default function RGPD() {
  return (
    <div className="min-h-screen bg-[#050B14] text-slate-100">
      <div className="max-w-3xl mx-auto px-6 py-24">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full border border-white/10 bg-white/[0.04] text-[11px] font-semibold uppercase tracking-[0.2em] text-blue-300 mb-8">
          <ShieldCheck className="h-3.5 w-3.5" />
          Privacidade & RGPD
        </div>

        <h1 className="text-4xl sm:text-5xl font-semibold tracking-tighter text-white leading-[1.05] mb-4">
          Conformidade com o RGPD
        </h1>
        <p className="text-slate-400 text-lg mb-12">Última actualização: Maio de 2026</p>

        <div className="space-y-10 text-slate-300 leading-relaxed">

          <Section title="A Automia e o RGPD">
            <p>A Automia está em plena conformidade com o Regulamento Geral sobre a Protecção de Dados (RGPD), aplicável na União Europeia desde 25 de Maio de 2018. Tratamos os dados pessoais dos seus clientes com rigor, transparência e segurança.</p>
          </Section>

          <Section title="Responsável pelo tratamento">
            <p>O responsável pelo tratamento dos dados é a entidade que contrata os serviços da Automia (o seu negócio). A Automia actua como subcontratante, processando dados apenas em conformidade com as suas instruções.</p>
          </Section>

          <Section title="Dados recolhidos">
            <p>No âmbito da prestação do serviço, a Automia pode processar os seguintes dados dos seus clientes:</p>
            <ul className="list-disc list-inside mt-3 space-y-1 text-slate-400">
              <li>Nome e contacto (telemóvel, e-mail)</li>
              <li>Histórico de conversas no WhatsApp</li>
              <li>Informação de marcações (data, hora, serviço)</li>
              <li>Notas e preferências registadas durante as conversas</li>
            </ul>
          </Section>

          <Section title="Base legal para o tratamento">
            <p>O tratamento é efectuado com base no interesse legítimo para a prestação do serviço contratado e no consentimento implícito do cliente ao iniciar a conversa com o seu negócio.</p>
          </Section>

          <Section title="Retenção de dados">
            <p>Os dados são conservados apenas pelo período necessário à prestação do serviço. Pode solicitar a eliminação dos dados em qualquer momento através do e-mail <a href="mailto:ola@automia.pt" className="text-blue-400 hover:text-blue-300">ola@automia.pt</a>.</p>
          </Section>

          <Section title="Segurança">
            <p>Toda a comunicação é cifrada em trânsito (TLS 1.3). Os dados são armazenados em servidores na União Europeia, com acesso restrito e auditado.</p>
          </Section>

          <Section title="Direitos dos titulares">
            <p>Os titulares dos dados têm direito a acesso, rectificação, apagamento, portabilidade e oposição ao tratamento. Para exercer estes direitos, contacte <a href="mailto:ola@automia.pt" className="text-blue-400 hover:text-blue-300">ola@automia.pt</a>.</p>
          </Section>

          <Section title="Contacto">
            <p>Para qualquer questão relacionada com privacidade e protecção de dados: <a href="mailto:ola@automia.pt" className="text-blue-400 hover:text-blue-300">ola@automia.pt</a></p>
          </Section>

        </div>

        <div className="mt-16 pt-8 border-t border-white/10">
          <a href="/" className="text-sm text-slate-400 hover:text-white transition-colors">← Voltar ao início</a>
        </div>
      </div>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-xl font-medium text-white mb-3">{title}</h2>
      {children}
    </div>
  );
}
